

// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import { AuthProvider, useAuth } from "./context/AuthContext";
// import { LocationProvider } from "./context/LocationContext";
// import LoginPopup from "./components/Auth/LoginPopup";
// import ProtectedRoute from "./components/Auth/ProtectedRoute";
// import AdminRoute from "./components/Auth/AdminRoute";
// import Navbar from "./components/Layout/Navbar";
// import Footer from "./components/Layout/Footer";
// import ScrollAnimation from "./components/Layout/ScrollAnimation";
// import Home from "./pages/Home";
// import About from "./pages/About";
// import Team from "./pages/Team";
// import Customers from "./pages/Customers";
// import Commercial from "./pages/Commercial";
// import Housing from "./pages/Housing";
// import Contact from "./pages/Contact";
// import Products from "./pages/Products";
// import ProductDetail from "./pages/ProductDetail";
// import Career from "./pages/Career";
// import Blog from "./pages/Blog";
// // IMPORT NEWS PAGES
// import News from "./pages/News";
// import NewsDetail from "./pages/NewsDetail";
// import CityPage from './pages/CityPage';
// import Residential from "./pages/Residential";
// import Industrial from "./pages/Industrial";
// import AdminLogin from "./components/Admin/AdminLogin";
// import AdminDashboard from "./components/Admin/AdminDashboard";

// // Separate component for main layout
// function MainLayout({ children }) {
//   const { showLoginPopup } = useAuth();

//   return (
//     <>
//       <Navbar />
//       <ScrollAnimation />
//       <main className="main-content">{children}</main>
//       <Footer />
//       {showLoginPopup && <LoginPopup />}
//     </>
//   );
// }

// function App() {
//   return (
//     <AuthProvider>
//       <LocationProvider>
//         <Router>
//           <div className="app-container">
//             <Routes>
//               {/* Admin Route */}
//               <Route
//                 path="/admin"
//                 element={
//                   <AdminRoute>
//                     <AdminDashboard />
//                   </AdminRoute>
//                 }
//               />

//               {/* Public Login (optional, if you want separate login page) */}
//               <Route path="/admin-login" element={<AdminLogin />} />

//               {/* All regular website routes */}
//               <Route
//                 path="/"
//                 element={
//                   <MainLayout>
//                     <Home />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/about"
//                 element={
//                   <MainLayout>
//                     <About />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/team"
//                 element={
//                   <MainLayout>
//                     <Team />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/customers"
//                 element={
//                   <MainLayout>
//                     <Customers />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/commercial"
//                 element={
//                   <MainLayout>
//                     <Commercial />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/residential"
//                 element={
//                   <MainLayout>
//                     <Residential />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/industrial"
//                 element={
//                   <MainLayout>
//                     <Industrial />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/housing"
//                 element={
//                   <MainLayout>
//                     <Housing />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/contact"
//                 element={
//                   <MainLayout>
//                     <Contact />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/products"
//                 element={
//                   <MainLayout>
//                     <Products />
//                   </MainLayout>
//                 }
//               />

//               {/* Product Detail Route */}
//               <Route
//                 path="/product/:id"
//                 element={
//                   <MainLayout>
//                     <ProductDetail />
//                   </MainLayout>
//                 }
//               />

//               {/* NEWS ROUTES - ADDED HERE */}
//               <Route
//                 path="/news"
//                 element={
//                   <MainLayout>
//                     <News />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/news/:id"
//                 element={
//                   <MainLayout>
//                     <NewsDetail />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/career"
//                 element={
//                   <MainLayout>
//                     <Career />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/blog"
//                 element={
//                   <MainLayout>
//                     <Blog />
//                   </MainLayout>
//                 }
//               />

//               <Route
//                 path="/city/:cityName"
//                 element={
//                   <MainLayout>
//                     <CityPage />
//                   </MainLayout>
//                 }
//               />

//               {/* Add a catch-all route */}
//               <Route path="*" element={<Navigate to="/" replace />} />
//             </Routes>
//           </div>
//         </Router>
//       </LocationProvider>
//     </AuthProvider>
//   );
// }

// export default App;





















// App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LocationProvider } from "./context/LocationContext";
import LoginPopup from "./components/Auth/LoginPopup";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import AdminRoute from "./components/Auth/AdminRoute";
import Navbar from "./components/Layout/Navbar";
import Footer from "./components/Layout/Footer";
import ScrollAnimation from "./components/Layout/ScrollAnimation";
import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import Customers from "./pages/Customers";
import Commercial from "./pages/Commercial";
import Housing from "./pages/Housing";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Career from "./pages/Career";
import Blog from "./pages/Blog";
// IMPORT NEWS PAGES
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import CityPage from './pages/CityPage';
import Residential from "./pages/Residential";
import Industrial from "./pages/Industrial";
import AdminLogin from "./components/Admin/AdminLogin";
import AdminDashboard from "./components/Admin/AdminDashboard";
// IMPORT INVOICE AND QUOTATION PAGES
import TestInvoice from './components/Admin/TestInvoice';
import SimpleInvoice from './components/Admin/SimpleInvoice';

// Add temporary routes

// import Invoice from "./pages/Invoice";
// import Quotation from "./pages/Quotation";

// Separate component for main layout
function MainLayout({ children }) {
  const { showLoginPopup } = useAuth();

  return (
    <>
      <Navbar />
      <ScrollAnimation />
      <main className="main-content">{children}</main>
      <Footer />
      {showLoginPopup && <LoginPopup />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <Router>
          <div className="app-container">
            <Routes>
              {/* Admin Route */}
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              />

              {/* Public Login (optional, if you want separate login page) */}
              <Route path="/admin-login" element={<AdminLogin />} />

              {/* TEST ROUTES - Add these here, before other routes */}
              <Route path="/test-pdf" element={<TestInvoice />} />
              <Route path="/simple-invoice" element={<SimpleInvoice />} />
              
              {/* All regular website routes */}
              <Route
                path="/"
                element={
                  <MainLayout>
                    <Home />
                  </MainLayout>
                }
              />

              <Route
                path="/about"
                element={
                  <MainLayout>
                    <About />
                  </MainLayout>
                }
              />

              <Route
                path="/team"
                element={
                  <MainLayout>
                    <Team />
                  </MainLayout>
                }
              />

              <Route
                path="/customers"
                element={
                  <MainLayout>
                    <Customers />
                  </MainLayout>
                }
              />

              <Route
                path="/commercial"
                element={
                  <MainLayout>
                    <Commercial />
                  </MainLayout>
                }
              />

              <Route
                path="/residential"
                element={
                  <MainLayout>
                    <Residential />
                  </MainLayout>
                }
              />

              <Route
                path="/industrial"
                element={
                  <MainLayout>
                    <Industrial />
                  </MainLayout>
                }
              />

              <Route
                path="/housing"
                element={
                  <MainLayout>
                    <Housing />
                  </MainLayout>
                }
              />

              <Route
                path="/contact"
                element={
                  <MainLayout>
                    <Contact />
                  </MainLayout>
                }
              />

              <Route
                path="/products"
                element={
                  <MainLayout>
                    <Products />
                  </MainLayout>
                }
              />

              {/* Product Detail Route */}
              <Route
                path="/product/:id"
                element={
                  <MainLayout>
                    <ProductDetail />
                  </MainLayout>
                }
              />

              {/* NEWS ROUTES */}
              <Route
                path="/news"
                element={
                  <MainLayout>
                    <News />
                  </MainLayout>
                }
              />

              <Route
                path="/news/:id"
                element={
                  <MainLayout>
                    <NewsDetail />
                  </MainLayout>
                }
              />

              <Route
                path="/career"
                element={
                  <MainLayout>
                    <Career />
                  </MainLayout>
                }
              />

              <Route
                path="/blog"
                element={
                  <MainLayout>
                    <Blog />
                  </MainLayout>
                }
              />

              <Route
                path="/city/:cityName"
                element={
                  <MainLayout>
                    <CityPage />
                  </MainLayout>
                }
              />

              {/* INVOICE AND QUOTATION ROUTES */}
              {/* <Route
                path="/invoice"
                element={
                  <MainLayout>
                    <Invoice />
                  </MainLayout>
                }
              />

              <Route
                path="/quotation"
                element={
                  <MainLayout>
                    <Quotation />
                  </MainLayout>
                }
              /> */}

              {/* Add a catch-all route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;